export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 no-underline">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">快看影视</span>
            </a>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              高清电视剧免费在线观看平台，汇聚最新电视剧、免费电视剧大全，秒开不卡顿，追剧一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">最新动态</a>
              <a href="#media" onClick={(e) => { e.preventDefault(); document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">精彩预告</a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热播榜单</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">精选推荐</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">古装仙侠</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">悬疑探案</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">韩剧热播</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">都市情感</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-500">更多合作伙伴即将上线</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2020-2026 快看影视 kuaikanys.com 版权所有。本站内容仅供交流学习，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}